import { PlanSearchType } from './plan-search-type.enum';
import { ProjectSectionUnitSearchRequest } from './project-section-unit-search-request.model';
import { ProjectSectionUnitStatus } from './project-section-unit-status.enum';
import { ProjectSectionUnitSubStatus } from './project-section-unit-sub-status.enum';

export class ProjectSectionUnitProgressSearchRequest extends ProjectSectionUnitSearchRequest {
  [key: string]: any;
  status?: ProjectSectionUnitStatus;
  subStatus?: ProjectSectionUnitSubStatus;
  startDate?: number;
  finishDate?: number;
  days?: number;
  planStartDate?: number;
  planFinishDate?: number;
  searchDate?: number;
  nowDate?: number;
  searchBeginDate?: number;
  searchEndDate?: number;
  searchType?: PlanSearchType;
  planDays?: number;
  actualComment?: string;
  planComment?: string;
  constructionFormCompleted?: boolean;
  constructionSelfFormCompleted?: boolean;
  superviseSpotFormCompleted?: boolean;
  superviseRecordFormCompleted?: boolean;
}
